module.exports = __webpack_public_path__ + "static/media/Pouť-95-MCoppa-8.1d3cdfc5.jpg";